<template>
  <div class="header"  v-if="user">
    <div class="zp-top">
      <div class="logo">
        <img src="http://sttts.org.cn/static/home/images/logo.png" alt="">
      </div>
      <div class="titleA">Study Travel Tutor Test Service</div>
      <div class="titleB">研学旅行指导师测评服务平台</div>
      <div class="btnBox">
        <a href="http://sttts.org.cn/" class="cp">
          <img src="/static/home/images/tongzhiL.png" alt="">
          通知
        </a>
        <a href="http://sttts.org.cn/home/ceping/index/1.html" class="cp">
          <img src="/static/home/images/cepingB.png" alt="">
          测评
        </a>
        <a href="http://zp.sttts.org.cn" class="tz">
          研学招聘
        </a>
      </div>
    </div>
    <div class="container header-box">
      <div class="header-left">
        <img src="http://sttts.org.cn/static/home/images/logo.png" alt="">
      </div>
      <div class="header-center">
        <div class="navItem" :class="{active: $route.path === '/org/receiveResume'}"
             @click="toPage('/org/receiveResume')">收到的简历</div>
        <div class="navItem" :class="{active: $route.path === '/org/postPosition'}"
             @click="toPage('/org/postPosition')">已发布的职位</div>
        <div class="navItem" :class="{active: $route.path === '/org/addPosition'}"
             @click="toPage('/org/addPosition')">发布职位</div>
        <!--        <div class="navItem" :class="{active: $route.path === '/org/internManage'}" @click="toPage('/org/internManage')">实习生管理</div>-->
        <div class="navItem" :class="{active: $route.path === '/org/capitalAccount'}"
             @click="toPage('/org/capitalAccount')">我的咸豆</div>
        <div class="navItem" :class="{active: $route.path === '/knowledge'}" @click="toPage('/knowledge')">知识</div>
      </div>
      <div class="header-right">
        <div class="navItem" :class="{active: $route.path === '/org/mail'}" @click="toPage('/org/mail')">站内信<i
          class="iconfont icondian"
          style="position: absolute;color: #e4393c;top: -5px;right: -25px; width: 40px;font-size: 40px;height: 40px;"
          v-if="halsRead"></i></div>
        <div class="navItem" :class="{active: $route.path === '/org/customerService'}"
             @click="toPage('/org/customerService')">客服</div>
        <div class="navItem" :class="{active: $route.path === '/org/about'}"
             @click="toPage('/org/about')">关于我们</div>
        <el-dropdown>
          <div class="navItem" :class="{active: isUser}" style="position: relative">
            机构中心<i class="el-icon-arrow-down el-icon--right"></i>
            <div
              v-if="user.certification !== 2 ||user.status !== 0"
              style="position: absolute;left: -5px;bottom: 2px;color: #fff;height: 22px;line-height: 22px;text-align: left;    width: 80px;border: 1px solid #fff;background: #e7393c;border-radius: 3px;text-align: center;">
              <span v-if="user.certification === 0">未认证</span>
              <span v-if="user.certification === 1">认证中</span>
              <span v-else-if="user.certification === 3">认证失败</span>
              <span v-if="user.status === 1">不信任</span>
              <span v-else-if="user.status === 2">拉黑</span>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="toPage('/org/userInfo/orgInfo')">机构信息</el-dropdown-item>
            <el-dropdown-item @click.native="toPage('/org/userInfo/accountInfo')" v-if="is_execute!==1">账户信息
            </el-dropdown-item>
            <!--            <el-dropdown-item @click.native="toPage('/org/userInfo/orgVip')">开通会员</el-dropdown-item>-->
            <el-dropdown-item @click.native="toPage('/org/userInfo/orgHelp')">帮助中心</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="navItem" @click="tuichu">退出登录</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "headerDiv",
    data() {
      return {
        isLogin: false,
        address: {
          categoryname: "北京市",
          city_id: 110100,
          parentid: 1,
          spell: "beijingshi"
        },
        region: [],
        halsRead: false,   //  是否有未读的站内信
        is_execute: 0,
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },
      // 是否显示logo
      isLogo() {
        return this.$store.state.isLogo
      },
      // 是否个人中心的页面
      isUser() {
        let myPath = '/org/user'
        let regExp = new RegExp(myPath)
        return regExp.test(this.$route.path)
      }
    },
    created() {
      this.is_execute = this.$store.state.user.is_execute
      if (this.user !== null && this.user !== '' && this.user.user_token) {
        this.isLogin = true
        this.getNoRead()
      } else {
        this.isLogin = false
      }
    },

    methods: {
      //  获取是否有未读的站内信
      getNoRead() {
        this.$api.apiContent.getInsideLettersNoReadCount({
          userToken: this.user.user_token
        })
          .then(res => {
            res.data === 0 ? this.halsRead = false : this.halsRead = true
          }).catch(res => {
          res.data === 0 ? this.halsRead = false : this.halsRead = true
        })
        this.$api.apiMember.ShowCandidateInfo({
          userToken: this.$store.state.user.user_token,
          isExecute: this.$store.state.user.is_execute
        }).then(res => {
          this.$store.state.user = res.data
        }).catch(e => {
          console.log(e)
        })
      },
      choiceRegion(command) {
        this.region.map(item => {
          if (item.city_id === command) {
            this.address = item
            this.$store.state.selectionAddress = item
          }
        })
      },
      // 跳转页面
      toPage(router) {
        this.$router.push(router)
      },
      // 退出登录
      tuichu() {
        this.$confirm('是否退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$store.state.user = null
          this.$store.state.userType = null
          window.localStorage.clear()
          window.sessionStorage.clear()
          window.location.href = '/home/index'
          this.$message({
            type: 'success',
            message: '退出成功'
          })
        }).catch(() => {
        })
      }
    },
    watch: {
      user() {
        if (this.user && this.user.user_token) {
          this.isLogin = true
        } else {
          this.isLogin = false
        }
      },
      '$route': 'getNoRead'
    }
  }
</script>

<style scoped lang="scss">
  .header {
    background-color: #005eb5;
    //height: 66px;

    .zp-top {
      background: #fff;

      .logo {
        width: 100%;
        text-align: center;
        padding-top: 40px;
        padding-bottom: 15px;
        position: relative;
      }

      .titleA {
        width: 100%;
        text-align: center;
        font-size: 24px;
        color: #333333;
        line-height: 28px;
      }

      .titleB {
        width: 100%;
        line-height: 59px;
        text-align: center;
        font-size: 42px;
        color: #333333;
        font-weight: bold;
      }

      .btnBox {
        width: 100%;
        display: flex;
        justify-content: center;
        padding-top: 20px;

        .tz {
          width: 188px;
          height: 50px;
          background-color: #005eb5;
          border-radius: 6px 6px 0px 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
          color: #ffffff;
          margin: 0 10px;
        }

        .cp {
          width: 188px;
          height: 50px;
          background-color: #cfe8ff;
          border-radius: 6px 6px 0px 0px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
          color: #005eb5;
          margin: 0 10px;
        }
      }
    }

    .header-box {
      display: flex;
      align-items: center;

      .header-left {
        display: flex;
        width: 120px;

        img {
          display: block;
          height: 55px;
        }

        .item {
          width: 100px;
          line-height: 66px;
          text-align: center;
          color: #fff;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .item.address {
          color: #f39e00;
          font-size: 16px;

          b {
            padding: 0 10px;
          }
        }
      }

      .header-center {
        width: 700px;
        padding: 0 90px;
        display: flex;
        justify-content: space-between;

        .navItem {
          display: inline-block;
          margin: 0 10px;
          line-height: 66px;
          color: #fff;
          cursor: pointer;
          position: relative;
          font-size: 17px;
        }

        /*.navItem.active {*/
        /*  color: #00a2ea;*/
        /*}*/
      }

      .header-right {
        width: 440px;
        display: flex;
        justify-content: space-between;

        .navItem {
          display: inline-block;
          margin: 0 10px;
          line-height: 66px;
          color: #fff;
          cursor: pointer;
          position: relative;
          font-size: 17px;
        }

        /*.navItem.active {*/
        /*  color: #00a2ea;*/
        /*}*/
      }
    }
  }

  .el-dropdown-link {
    color: #fff;
  }

  .active {
    color: #f39e00 !important;
  }

  *:focus {
    outline: none;
  }
</style>
